import script from "./MemberEnrollment.vue?vue&type=script&setup=true&lang=js"
export * from "./MemberEnrollment.vue?vue&type=script&setup=true&lang=js"

import "./MemberEnrollment.vue?vue&type=style&index=0&id=39d8e34d&scoped=true&lang=css"

import exportComponent from "/Users/alberto/sites/newform/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-39d8e34d"]])

export default __exports__